import contactService from './contact-service';

const request = {
    submitContact: contactService.submitContact
};

export default request;
